import React, { Component } from 'react';

class WithTemp extends Component {
	componentWillMount() {
		document.getElementById('js-withdrawal-flow-temp').classList.add('withdrawal--open');
	}

	componentWillUnmount() {

	}

	render() {
		return (
			<div id="withtemp" />
		);
	}
}

export default WithTemp;




// WEBPACK FOOTER //
// ./mobile-core/src/components/withtemp.js